export { default } from './InlinePageRanges';
